const css = `.holidays-dialog {
  width: 90vw;
  max-width: 1400px;
  container-type: inline-size;
}
.holidays-dialog .p-dialog-content {
  padding: 16px;
  overflow-x: hidden;
}
.holidays-dialog .copy-holidays-section {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  align-items: center;
  justify-content: center;
}
.holidays-dialog .copy-holidays-section .copy-holidays-dropdown {
  width: 300px;
}
.holidays-dialog .copy-holidays-section .p-button {
  width: 40px;
  height: 40px;
  padding: 0;
}
.holidays-dialog .holidays-calendar-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, 330px);
  gap: 24px;
  justify-content: space-evenly;
}
.holidays-dialog .holidays-calendar-grid .month-calendar {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 330px;
}
.holidays-dialog .holidays-calendar-grid .month-calendar h5 {
  margin-bottom: 8px;
  text-transform: capitalize;
  color: var(--text);
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar {
  width: 100%;
  height: 366px;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker {
  width: 100%;
  min-width: unset;
  padding: 8px;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker table {
  margin: 0;
  width: 100%;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker table th {
  padding: 8px 0;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker table td {
  padding: 4px;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker table td.p-datepicker-other-month {
  visibility: hidden;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker table td > span {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker table td.p-highlight > span {
  background: var(--accent);
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker .p-datepicker-header {
  padding: 8px;
  border: none;
}
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker .p-datepicker-header .p-datepicker-prev,
.holidays-dialog .holidays-calendar-grid .month-calendar .holiday-calendar .p-datepicker .p-datepicker-header .p-datepicker-next {
  display: none;
}

@container (max-width: 1400px) {
  .holidays-calendar-grid {
    grid-template-columns: repeat(3, 330px) !important;
  }
}
@container (max-width: 1100px) {
  .holidays-calendar-grid {
    grid-template-columns: repeat(2, 330px) !important;
  }
}
@container (max-width: 750px) {
  .holidays-calendar-grid {
    grid-template-columns: 330px !important;
  }
}
@media (max-width: 768px) {
  .holidays-dialog {
    width: 100vw;
    height: 100vh;
    margin: 0;
  }
  .holidays-dialog .p-dialog-content {
    padding: 8px;
  }
  .holidays-dialog .holidays-calendar-grid {
    gap: 16px;
  }
}
@media (max-width: 480px) {
  .p-dialog.big-modal.holidays-dialog {
    padding-left: 4px;
    padding-right: 0;
    padding-bottom: 0;
  }
  .p-dialog.big-modal.holidays-dialog .p-dialog-content {
    padding-left: 4px;
    padding-right: 4px;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
